import { Component } from '@angular/core';
import {
    CmpsDialogRef,
    CmpsSnackBar,
    CmpsTextOnlySnackBarComponent,
    CmpsTextOnlySnackBarOptions,
} from '@cmps/ng-uikit';
import { of } from 'rxjs';
import { tap } from 'rxjs/operators';

import {
    TakeUntilDestroy,
    takeUntilDestroy,
} from '../../../../common/take-until-destroy.decorator';
import { currentBuilderState } from '../../builder.state';
import { createPreset } from '../../function/create-preset.function';
import { BuilderState } from '../../model/builder-state.model';

@Component({
    selector: 'cmps-report-builder-save-preset-dialog',
    templateUrl: './save-preset-dialog.component.html',
})
@TakeUntilDestroy()
export class SavePresetDialogComponent {
    /** @private */
    _state: BuilderState;

    /** @private */
    _name: string;

    constructor(
        /** @private */ readonly _dialogRef: CmpsDialogRef<
            SavePresetDialogComponent,
            void
        >,
        private readonly _snackBar: CmpsSnackBar,
    ) {
        this._state = currentBuilderState();
    }

    /** @private */
    _onSaveClick(): void {
        this._state.creatingPreset = true;

        createPreset(this._name)
            .pipe(
                tap((ret) => {
                    this._state.creatingPreset = false;

                    if (ret?.presetId == null) {
                        return of(null);
                    }

                    this._dialogRef.close();

                    const data: CmpsTextOnlySnackBarOptions = {
                        text: 'Saved',
                    };

                    this._snackBar.open(CmpsTextOnlySnackBarComponent, {
                        duration: 2500,
                        placement: 'bottom-right',
                        data,
                    });
                }),
                takeUntilDestroy(this),
            )
            .subscribe();
    }
}
